// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#header[data-v-695adb52] {\n  background-color: #272A33;\n  position: sticky;\n  top: 0;\n  z-index: 5;\n}\n#header_body[data-v-695adb52] {\n  height: 50px;\n}\n.v-list[data-v-695adb52] {\n  background: #171921;\n}\n[data-v-695adb52] .v-list-item__title {\n  color: white;\n}\n[data-v-695adb52] .v-input__slot {\n  padding-right: 2px !important;\n}\n[data-v-695adb52] .v-input__append-inner {\n  margin-top: 16px !important;\n  padding-left: 0px !important;\n}", ""]);
// Exports
module.exports = exports;
